import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Link,
  List,
  ListItem,
  Button,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import { motion } from "framer-motion";
import { Navigate, useNavigate } from "react-router-dom";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import BuildIcon from "@mui/icons-material/Build";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import Tooltip from "../../components/Tooltip/Tooltip";
import GuestSpeakers from "../../components/Speakers/Speakers";

const AboutSummerResidency2025 = () => {
  useEffect(() => {
    document.title = "About Summer Residency - MS Digital Hub";
  }, []);
  const navigate = useNavigate();
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <Box
        sx={{
          width: "auto",

          padding: "0px 20px",
          margin: "0px auto",
          padding: { xs: "20px", sm: "30px", md: "1px 80px" },
          border: "none",
          backgroundColor: "#ffffff",
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          Summer 2025 Residency
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Faculty at all Mississippi institutions of higher education, including
          community colleges, are invited to apply to a residential two-week
          summer course offered by The University of Southern Mississippi’s
          Digital Humanities Hub at USM’s Hattiesburg, Mississippi campus. The
          Mississippi Digital Humanities Hub is a three-year grant-funded
          project to provide Mississippi instructors and students with the
          digitization and digital humanities skills they need to identify,
          digitize, and explain collections of documents (historical, cultural,
          literary) in their communities.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Participants will learn the basics of digitization, metadata, and
          electronic preservation, in addition to general digital humanities
          tools—such as mapping, visualizations, and textual and network
          analysis—from experts affiliated with the Center for Digital
          Humanities at Southern Miss and the Mississippi Digital Library.
          Participants will acquire the skills required to plan and conduct
          community digitization projects and to apply for digitization grants,
          with the larger goal of assisting their colleagues, students, and
          surrounding communities preserve and better understand their history
          and experiences.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          This two-week course is for Mississippi faculty, museum professionals,
          and archivists only, and will take place from Monday, June 16, 2025,
          through Friday, June 27, 2025. Participants will be provided with
          housing, most meals, travel reimbursement, and small stipends.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            lineHeight: "1.8",
            textAlign: "justify",
          }}
        >
          Applications are due by 11:59 PM (CT) on April 15, 2025. Participation
          is limited to ten spots, however, so please apply as soon as possible.
        </Typography>
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
          }}
        >
          Summer 2025 Guest Speaker Brief Bios{" "}
        </Typography>
        <GuestSpeakers />
      </Box>
    </motion.div>
  );
};

export default AboutSummerResidency2025;
